import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import AppAdminHeader from './admin-header';
import AppAdminBody from './admin-body';
import { DBLogo } from '@dbk/ui-icons';

class AppAdmin extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { auth } = this.props;
    return (
      <div className="scene profile-container">
        <div className="row small-12 large-8">
          <div className="border-none">
            <DBLogo />
            <AppAdminHeader />
            <AppAdminBody />
          </div>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {},
})(AppAdmin);
